import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-gender-icon',
	templateUrl: './gender-icon.component.html',
	styleUrl: './gender-icon.component.scss'
})
export class GenderIconComponent {
	@Input() gender: any;
	getIcon() {
		let icon = "male";
		if (this.gender && this.gender.toLowerCase() == "female") {
			icon = "female";
		}
		return '../../../assets/img/' + icon + '.png';
	}
}
